import { isWhatsAppMsPlatform } from '../../../../services/inbox/inboxMsChatPlatform';

/** Retailer can sync/send flows via Mercately BSP or Gupshup (legacy or inbox MS flags). */
export const canSyncWhatsappFlows = (retailerInfo) =>
  Boolean(
    retailerInfo?.connect_bsp_mercately
    || retailerInfo?.gs_integrated
    || retailerInfo?.whatsapp_bsp_messages_integrated
    || retailerInfo?.whatsapp_gupshup_messages_integrated
  );

/** Inbox quick action: WhatsApp chat (legacy or MS) with BSP/Gupshup flows support. */
export const shouldShowWhatsappFlowsInboxQuickAction = (platform, retailerInfo) =>
  isWhatsAppMsPlatform(platform) && canSyncWhatsappFlows(retailerInfo);

export const isSyncBlocked = (retailerInfo) =>
  Boolean(retailerInfo && !canSyncWhatsappFlows(retailerInfo));

export const getWhatsappFlowsConnectionRequirement = (retailerInfo) => {
  if (retailerInfo?.connect_bsp_mercately) return 'ready';
  if (retailerInfo?.gs_integrated) return 'upgrade';
  return 'missing';
};

export const resolveSyncState = (flows, lastSyncedAt) => {
  if ((flows || []).length > 0) return 'has_flows';
  if (lastSyncedAt) return 'synced_empty';
  return 'initial';
};
